export default __webpack_public_path__ + "static/media/SG13.ab23719f.webp";